export interface FormAssignment {
  id?: string;
  invoiceId: string; 
  formType: any;
  assignedTo?: string;
  status: AssignmentStatus;
  dueDate?: Date;
}

export enum FormType {
  EntertainmentDetails = 'Entertainment Details',
  TravelExpense = 'Travel Expense',
  MealAllowance = 'Meal Allowance'
}

export enum AssignmentStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed'
}
